import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { translate } from 'secullum-i18n';
import {
  ErrorMessage,
  Card,
  RangeDatePicker,
  DropDown,
  Space,
  ImageButton,
  Message
} from 'secullum-react-native-ui';
import { estiloTextoBotaoDestaque } from '../../../shared/components/BotaoDestaque';
import { ButtonBar } from '../../../shared/components/ButtonBar';
import { BatidasContainer } from '../../../shared/containers/BatidasContainer';
import { FuncionarioContainer } from '../../../shared/containers/FuncionarioContainer';
import withContainer from '../../../shared/containers/withContainer';
import Api from '../../../shared/modules/api';
import {
  Amarelo100,
  Cinza100,
  isDesktop
} from '../../../shared/modules/layout';
import { DadosListagemFuncionariosGerente } from '../../../shared/modules/types';
import {
  converterDataParaTimezoneBrasil,
  getDataInicioDiasAtras
} from '../../../shared/modules/utils';
import CartaoPontoCompleto from '../../../shared/screens/cartao-ponto/CartaoPontoCompleto';
import { TipoDeTela } from '../../../shared/screens/cartao-ponto/DetalheDiaBatida';
import LoggedInScreen from '../../components/LoggedInScreen';
import { RouteComponentComBancoIdProps } from '../../modules/routes';
import CartaoPontoResumido from '../cartao-ponto/CartaoPontoResumido';
import ModalImprimir from '../cartao-ponto/ModalImprimir';

type Visualizacao = 'resumido' | 'completo';

interface Props
  extends RouteComponentComBancoIdProps<{
    funcionarioSelecionadoId?: number;
  }> {
  batidasContainer: BatidasContainer;
  funcionarioContainer: FuncionarioContainer;
}

interface State {
  visualizacao: Visualizacao;
  filtros: {
    dataInicio: Date;
    dataFinal: Date;
    funcionarioId: number;
  };
  erroGeral: string;
  chaveTabela: number;
  funcionariosGerente: DadosListagemFuncionariosGerente[];
  exibirModalImprimir: boolean;
  bloquearBotaoImprimir: boolean;
}

class CartaoPontoGerente extends React.Component<Props, State> {
  state: State = {
    visualizacao: 'resumido',
    filtros: {
      dataInicio: converterDataParaTimezoneBrasil(getDataInicioDiasAtras(14)),
      dataFinal: converterDataParaTimezoneBrasil(new Date()),
      funcionarioId: 0
    },
    erroGeral: '',
    chaveTabela: 0,
    funcionariosGerente: [],
    exibirModalImprimir: false,
    bloquearBotaoImprimir: false
  };

  async componentDidMount() {
    const api = new Api();
    this.props.batidasContainer.limparLista();

    const { dados: funcionarioDados } = this.props.funcionarioContainer.state;

    let funcionarioId = Number(
      this.props.match.params.funcionarioSelecionadoId
    );

    await api.getListaFuncionariosGerente({
      onSuccess: listaOriginal => {
        const funcionariosGerente = listaOriginal.filter(
          x => x.id !== funcionarioDados.id
        );

        if (!funcionarioId) {
          funcionarioId = funcionariosGerente[0]?.id ?? 0;
        }

        this.setState(
          prevState => ({
            funcionariosGerente,
            filtros: {
              ...prevState.filtros,
              funcionarioId
            }
          }),
          async () => await this.handleModeChange('resumido')
        );
      },
      onError: resp => {
        this.setState({
          erroGeral: resp.message
        });
      }
    });
  }

  handleFuncionarioChange = async (funcionarioId: number) => {
    const filtros = {
      ...this.state.filtros,
      funcionarioId
    };

    this.setState({ filtros }, async () => {
      await this.handleModeChange(this.state.visualizacao);
    });
  };

  handleDateChange = (value: Date, name: keyof State['filtros']) => {
    const filtros = {
      ...this.state.filtros,
      [name]: value
    };

    if (name === 'dataInicio') {
      filtros.dataFinal = value;
    }

    this.setState(
      {
        filtros,
        chaveTabela: this.state.chaveTabela + 1,
        erroGeral: ''
      },
      async () => {
        if (name === 'dataFinal') {
          if (this.state.filtros.dataInicio > this.state.filtros.dataFinal) {
            this.setState({
              erroGeral: translate('Selecione o período corretamente')
            });

            return;
          }

          await this.handleModeChange(this.state.visualizacao);
        }
      }
    );
  };

  handleModeChange = async (mode: Visualizacao) => {
    if (
      this.state.erroGeral.length > 0 ||
      this.state.filtros.funcionarioId === 0
    ) {
      return;
    }

    this.setState({
      visualizacao: mode,
      chaveTabela: this.state.chaveTabela + 1,
      bloquearBotaoImprimir: false
    });

    await this.props.batidasContainer.loadCartaoPontoAsync(this.state.filtros);
  };

  handleExibirModalImprimir = () => {
    if (this.state.bloquearBotaoImprimir) {
      return;
    }

    this.setState({ exibirModalImprimir: true });
  };

  handleFecharModalErro = () => {
    this.props.batidasContainer.limparErro();
    this.setState({ bloquearBotaoImprimir: true });
  };

  render() {
    const {
      visualizacao,
      filtros,
      erroGeral,
      funcionariosGerente,
      exibirModalImprimir
    } = this.state;

    const { batidasContainer } = this.props;

    const { dados: funcionarioDados } = this.props.funcionarioContainer.state;

    const listaDiaResumido = batidasContainer.listaOrdenada();

    return (
      <LoggedInScreen screenTitle={translate('Cartões Ponto')}>
        <Card>
          {!isDesktop() && visualizacao === 'completo' ? (
            <View style={styles.headerCartaoPonto}>
              <Card.Header title={translate('Filtrar')} />
              <ImageButton
                nativeID="cartao-ponto-completo-imprimir-mobile-view"
                icon="print"
                style={styles.printButtonMobile}
                onPress={this.handleExibirModalImprimir}
              />
            </View>
          ) : (
            <Card.Header title={translate('Filtrar')} />
          )}
          <Card.Section style={styles.section}>
            <DropDown
              nativeID="cartao-ponto-funcionarios"
              style={styles.campoFiltro}
              label={translate('Selecione o funcionário')}
              value={filtros.funcionarioId}
              items={funcionariosGerente.map((x, indice) => ({
                value: x.id,
                label: x.nome,
                nativeID: `funcionario-${indice + 1}`
              }))}
              onChange={funcionarioId =>
                this.handleFuncionarioChange(funcionarioId)
              }
              emptyMessage={translate('Sua busca não retornou resultados')}
            />
            <RangeDatePicker
              nativeID="cartao-ponto-data"
              style={styles.campoFiltro}
              label={translate('Insira o Período')}
              startDate={filtros.dataInicio}
              endDate={filtros.dataFinal}
              onStartDateChange={date =>
                this.handleDateChange(date, 'dataInicio')
              }
              onEndDateChange={date => this.handleDateChange(date, 'dataFinal')}
            />
            <ErrorMessage
              nativeID="cartao-ponto-erro-geral"
              message={erroGeral}
            />
            <ButtonBar
              buttonBarStyle={styles.buttons}
              leftButton={{
                nativeID: 'cartao-ponto-resumido',
                text: translate('Resumido'),
                onPress: () => this.handleModeChange('resumido'),
                textStyle: [
                  styles.textButton,
                  visualizacao !== 'resumido' && estiloTextoBotaoDestaque
                ],
                style: [
                  styles.button,
                  {
                    backgroundColor:
                      visualizacao === 'resumido' ? Cinza100 : Amarelo100
                  }
                ]
              }}
              rightButton={{
                nativeID: 'cartao-ponto-completo',
                text: translate('Completo'),
                onPress: () => this.handleModeChange('completo'),
                textStyle: [
                  styles.textButton,
                  visualizacao !== 'completo' && estiloTextoBotaoDestaque
                ],
                style: [
                  styles.button,
                  {
                    backgroundColor:
                      visualizacao === 'completo' ? Cinza100 : Amarelo100
                  }
                ]
              }}
            />
            {visualizacao === 'completo' && isDesktop() && (
              <>
                <Space width={16} />
                <ImageButton
                  nativeID="cartao-ponto-completo-imprimir"
                  icon="print"
                  style={styles.printButton}
                  onPress={this.handleExibirModalImprimir}
                />
              </>
            )}
          </Card.Section>
        </Card>
        {visualizacao === 'resumido' ? (
          <CartaoPontoResumido
            funcionarioId={filtros.funcionarioId}
            listaOrdenada={listaDiaResumido}
            key={this.state.chaveTabela}
            tipoTela={TipoDeTela.CartaoPontoGerente}
          />
        ) : (
          <CartaoPontoCompleto
            batidas={listaDiaResumido}
            totais={batidasContainer.state.dados.totais}
          />
        )}
        {exibirModalImprimir && (
          <ModalImprimir
            configuracoesEspeciaisAcesso={
              funcionarioDados.configuracoesEspeciaisAcesso
            }
            funcionarioId={filtros.funcionarioId}
            filtros={filtros}
            dados={batidasContainer.state.dados}
            onRequestClose={opcoes => {
              batidasContainer.atualizarOpcoesCartaoPonto(opcoes);
              this.setState({ exibirModalImprimir: false });
            }}
            tipoPlano={funcionarioDados.plano}
          />
        )}
        <Message
          type="warning"
          visible={this.props.batidasContainer.state.erro !== ''}
          message={this.props.batidasContainer.state.erro}
          onRequestClose={this.handleFecharModalErro}
        />
      </LoggedInScreen>
    );
  }
}

const styles = StyleSheet.create({
  buttons: {
    flex: 1,
    height: 56,
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: 350,
    minWidth: 220,
    marginLeft: 16
  },
  button: {
    height: 42,
    maxWidth: 138
  },
  campoFiltro: {
    flex: 1,
    minWidth: 250,
    maxWidth: 350,
    marginLeft: 16
  },
  section: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingLeft: 0
  },
  textButton: {
    fontSize: 14
  },
  printButton: {
    marginVertical: 'auto',
    marginLeft: 'auto',
    padding: 5
  },
  printButtonMobile: {
    marginVertical: 'auto',
    marginLeft: 'auto',
    marginRight: 5,
    padding: 5
  },
  headerCartaoPonto: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
});

export default withContainer(
  FuncionarioContainer,
  'funcionarioContainer'
)(withContainer(BatidasContainer, 'batidasContainer')(CartaoPontoGerente));
